import LoadingModal from './LoadingModal';

export interface OrderConfirmingModalProps {}

export default function OrderConfirmingModal({}: OrderConfirmingModalProps) {
  return (
    <LoadingModal
      title="Betalning genomförd!"
      message="Din betalning har genomförts. Vi bekräftar din beställning. Vänta ett ögonblick..."
    />
  );
}
